export default {
      id: "txt_paragraph-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#txt_paragraph",
      toString: function () {
        return this.url;
      }
    }